
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{staticClass:"i-fill",attrs:{"x":"3.5","y":"26.5","width":"27.577","height":"27.577","rx":"1","transform":"rotate(-45 3.5 26.5)","fill":"#D0EFEC"}}),_c('g',{staticClass:"i-strokes",attrs:{"stroke":"#234652"}},[_c('path',{staticClass:"i-Vector 10",attrs:{"d":"M24 35.5v-8.095s4.704-4.342 9-8.405","stroke-linecap":"square"}}),_c('path',{staticClass:"i-Vector 11",attrs:{"d":"M24 27.405 16 19","stroke-linecap":"square"}}),_c('path',{staticClass:"i-Rectangle 35",attrs:{"d":"M4.707 23 24 3.707 43.293 23 24 42.293 4.707 23Z"}}),_c('path',{staticClass:"i-Rectangle 37",attrs:{"d":"M33.73 23.779v-5.583h-5.582"}}),_c('path',{staticClass:"i-Rectangle 38",attrs:{"d":"M20.73 18.196h-5.582v5.582"}})])])
          )
        }
      }
    